import { useBreakpoints } from '@vueuse/core';

export function useDevice() {
	const breakpoints = useBreakpoints({
		laptop: 992,
	});

	const isMobile = breakpoints.smaller('laptop');
	const isLaptop = breakpoints.greaterOrEqual('laptop');

	return { isMobile, isLaptop };
}
